import React, { useContext } from 'react';
import { Navigate } from "react-router-dom";
import AdminHeader from "../components/global/AdminHeader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../components/auth/auth-context";
import AdminFooter from '../components/global/AdminFooter';

const PrivateLayout = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <div>
            <AdminHeader />
            {children}
            <AdminFooter/>
            <ToastContainer
                position="top-right"
                autoClose={100}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
};

export default PrivateLayout;